import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';

import { BoxTogglerService } from '../services/box-toggler.service';

@Directive({
  selector: '[boxToggler]'
})
export class BoxTogglerDirective implements OnInit, OnChanges, OnDestroy {
  @Input('boxContent') boxContent: string;
  @Input() isOpen: boolean;

  private clickHandler: () => void;

  constructor (
    private el            : ElementRef,
    private boxTogglerApi : BoxTogglerService
  ) {}

  ngOnInit () : void {
    if (this.isOpen === undefined) {
      this.isOpen = true;
    }

    this.clickHandler = () => {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.open();
      } else {
        this.close();
      }
    };

    this.el.nativeElement.addEventListener('click', this.clickHandler);

    setTimeout(() => {
      if (this.isOpen) {
        this.open(true);
      } else {
        this.close(true);
      }
    });
  }

  ngOnChanges ( changes: SimpleChanges ) : void {
    if (changes.isOpen && !changes.isOpen.firstChange) {
      if (changes.isOpen.currentValue) {
        this.open();
      } else {
        this.close();
      }
    }
  }

  ngOnDestroy () : void {
    this.el.nativeElement.removeEventListener('click', this.clickHandler);
  }

  private close ( skipAnimation = false ) : void {
    const contentElement = this.boxTogglerApi.getContentElement(this.boxContent);

    this.boxTogglerApi.close($(this.el.nativeElement), contentElement, skipAnimation);
  }

  private open ( skipAnimation = false ) : void {
    const contentElement = this.boxTogglerApi.getContentElement(this.boxContent);

    this.boxTogglerApi.open($(this.el.nativeElement), contentElement, skipAnimation);
  }
}
